import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseLayoutComponent } from './base-layout/base-layout.component';
import { PageNotFoundComponent } from '@shared/page-not-found/page-not-found.component';

const appRoutes: Routes = [
  { path: '', loadChildren: () => import('@app/non-layout/non-layout.module').then(m => m.NonLayoutModule) },
  {
    path: '',
    component: BaseLayoutComponent,
    children: [
      { path: 'search', loadComponent: () => import('./global/search/search.component').then(c => c.SearchComponent) },
      { path: 'auth', loadChildren: () => import('@app/auth/auth.module').then(m => m.AuthModule) },
      { path: 'course', loadChildren: () => import('@app/course/course.module').then(m => m.CourseModule) },
      { path: 'tk', loadChildren: () => import('@app/itembank/itembank.module').then(m => m.ItembankModule) },
      { path: 'exercise', loadChildren: () => import('@app/exercise/exercise.module').then(m => m.ExerciseModule) },
      { path: 'task', loadChildren: () => import('@app/task/task.module').then(m => m.TaskModule) },
      { path: 'analysis', loadChildren: () => import('@app/analysis/analysis.module').then(m => m.AnalysisModule) },
      { path: 'classroom', loadChildren: () => import('@app/classroom/classroom.module').then(m => m.ClassroomModule) },
      { path: 'dashboard', loadChildren: () => import('@app/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'booklet', loadChildren: () => import('@app/booklet/booklet.module').then(m => m.BookletModule) },
      { path: 'bo', loadChildren: () => import('@app/bo/backoffice.module').then(m => m.BackOfficeModule) },
      { path: 'exam', loadChildren: () => import('@app/exam/exam.module').then(m => m.ExamModule) },
      {
        path: 'vocabulary',
        loadChildren: () => import('@app/vocabulary/vocabulary.module').then(m => m.VocabularyModule),
      },
      { path: 'target', loadChildren: () => import('@app/target/target.module').then(m => m.TargetModule) },
      { path: 'input', loadChildren: () => import('@app/input/input.module').then(m => m.InputModule) },
      { path: 'algo', loadChildren: () => import('@app/algo/algo.module').then(m => m.AlgoModule) },
      {
        path: 'student-survey',
        loadChildren: () => import('@app/student-survey/student-survey.module').then(m => m.StudentSurveyModule),
      },
      { path: '**', component: PageNotFoundComponent },
    ],
  },
];

@NgModule({
  // Angular 22 起 paramsInheritanceStrategy 默认值由 'emptyOnly' 变为 'always'，
  // 显式钉回旧值保持升级零行为变化（切换 'always' 需另立专项评估路由取参影响）
  imports: [RouterModule.forRoot(appRoutes, { enableTracing: false, paramsInheritanceStrategy: 'emptyOnly' })],
  exports: [RouterModule],
})
export class AppRouteModule {}
